import { Validators } from "@angular/forms";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
} from "@hardcode-kz/ui";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { IEquipmentModel } from "@app/shared/data-access/src/lib/resource-management/models/equipment";

export class EquipmentModelConfig implements IBaseConfig {
  version: number = 1;
  dicType = ResourceManagementEndpoints.EquipmentModel;
  isCrudByModal = true;
  title = "dicTable.equipmentModels";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "brand",
      title: "dicTable.equipmentBrand",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.EquipmentBrand,
        validators: [Validators.required],
      } as IHardFormSelectParams,
    },
    {
      name: "sortOrder",
      title: "dicTable.sortOrder",
      type: HardFormFieldTypeEnum.Number,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  saveCallback(data: IEquipmentModel) {
    const brandId = data?.brand?.id;
    delete data?.brand;

    return { ...data, brandId };
  }

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IEquipmentModel[]> = {
    showDefaultActions: true,
    tableColumns: "44px auto auto auto",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.equipmentBrand",
        name: "name",
        type: HardTableColumnTypeEnum.Parent,
        parent: "brand",
      },
    ],
  };
}
